import {
    AfterViewInit,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { startWith, takeWhile, tap } from 'rxjs/operators';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { IGroup, IGroupType } from '../../IGroups';
import { UpdateGroups } from '../../store/actions';
import * as fromGroupsR from '../../store/reducer';

@Component({
    selector: 'ef-groups-add',
    templateUrl: './groups-add.component.html',
    styleUrls: ['./groups-add.component.scss'],
    standalone: false
})
export class GroupsAddComponent implements OnInit, AfterViewInit, OnDestroy {
    public addGroupsForm: UntypedFormGroup;
    public gpcFilterFormGroup: UntypedFormGroup;

    private groupsSub: Subscription;

    private componentActive = true;

    public purposeAdd = '';
    public categoryidAdd = '';
    public groupType = '';
    public groupNameAdd = '';

    public groups: Array<IGroup> = [];
    public newGroups: Array<IGroup> = [];
    public groupTypes: Array<IGroupType> = [];
    public filteredGroupTypes$: Observable<Array<IGroupType>>;

    constructor(
        public dialogRef: MatDialogRef<GroupsAddComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        @Inject(LoggingService) private log: LoggingService,
        private groupsStore: Store<fromGroupsR.State>
    ) {
        this.log.debug({ type: 'GroupsAddComponent:ctor', data });
        this.groupTypes = data.groupTypes;
        this.gpcFilterFormGroup = data.filterFormGroup;
        // this.gpc = data.gpc;
    }

    ngOnInit() {
        this.addGroupsForm = new UntypedFormGroup({
            groupName: new UntypedFormControl(),
            purpose: new UntypedFormControl(),
            groupTypes: new UntypedFormControl()
        });
    }

    ngOnDestroy() {
        this.componentActive = false;
        if (this.categoryidAdd !== '' && this.groupNameAdd !== '') {
            this.groupsSub = this.groupsStore
                .pipe(
                    takeWhile(() => this.componentActive),
                    select(fromGroupsR.getGroups)
                )
                .subscribe(groups => {
                    this.groups = groups;
                    this.log.verbose({
                        type: 'GroupsAddComponent:groups-subscribe',
                        groups,
                        newGroups: this.newGroups
                    });
                });

            const newGroup = this.groups.find(
                group => group.GroupName === this.groupNameAdd
            );

            if (this.gpcFilterFormGroup.controls['groups']) {
                this.gpcFilterFormGroup.controls['groups'].patchValue({
                    GroupID: newGroup.GroupID
                });
            }
            // this.groupsStore.dispatch(new LoadGroupMembers({ GroupID: newGroup.GroupID }))
            // this.groupsStore.dispatch(new LoadGroupElementTypes({ GroupID: newGroup.GroupID }))

            if (this.gpcFilterFormGroup.controls['purpose']) {
                this.gpcFilterFormGroup.controls['purpose'].setValue(
                    this.purposeAdd
                );
            }

            this.groupsSub.unsubscribe();
        }
    }

    saveGroup() {
        this.newGroups = [
            {
                Categoryid: this.categoryidAdd,
                GroupName: this.groupNameAdd,
                Purpose: this.purposeAdd,
                GroupID: null
            }
        ];
        this.groupsStore.dispatch(new UpdateGroups(this.newGroups));

        if (this.gpcFilterFormGroup.controls['groupTypes']) {
            this.gpcFilterFormGroup.controls['groupTypes'].patchValue({
                Categoryid: this.categoryidAdd
            });
        }

        this.dialogRef.close();
    }

    cancelAdd() {
        this.dialogRef.close();
    }


    ngAfterViewInit() {
        this.groupTypes = this.groupTypes.filter(
            t => t.Categoryid !== 'SYS000000000000000000000000000000000'
        );

        // fromEvent(this.saveGroupButton.nativeElement, 'click')
        //     .pipe(takeWhile(() => this.componentActive))
        //     .subscribe(x => {
        //         this.newGroups = [
        //             {
        //                 Categoryid: this.categoryidAdd,
        //                 GroupName: this.groupNameAdd,
        //                 Purpose: this.purposeAdd,
        //                 GroupID: null
        //             }
        //         ];
        //         this.groupsStore.dispatch(new UpdateGroups(this.newGroups));

        //         if (this.gpcFilterFormGroup.controls['groupTypes']) {
        //             this.gpcFilterFormGroup.controls['groupTypes'].patchValue({
        //                 Categoryid: this.categoryidAdd
        //             });
        //         }
        //         // this.groupsStore.dispatch(new LoadGroups({ Categoryid: this.newGroups[0].Categoryid }));

        //         this.dialogRef.close();
        //     });
        // fromEvent(this.cancelButton.nativeElement, 'click')
        //     .pipe(takeWhile(() => this.componentActive))
        //     .subscribe(x => {
        //         this.dialogRef.close();
        //     });

        this.addGroupsForm.controls['groupTypes'].valueChanges
            .pipe(
                takeWhile(() => this.componentActive),
                startWith(''),
                tap(value =>
                    this.log.debug({
                        type: 'GroupsAddComponent:groupTypes:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'GroupsAddComponent:groupTypes:valueChanges:subscribe',
                    value
                });
                if (value && value != "" && this.groupTypes && this.groupTypes.length > 0) {
                    this.groupTypes.forEach(x => {
                        if (x.GroupType === value.GroupType) {
                            this.groupType = x.GroupType;
                            this.categoryidAdd = x.Categoryid;
                        }
                    });
                }

            });

        this.addGroupsForm.controls['groupName'].valueChanges
            .pipe(
                takeWhile(() => this.componentActive),
                startWith(''),
                tap(value =>
                    this.log.debug({
                        type: 'GroupsAddComponent:groupName:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'GroupsAddComponent:groupName:valueChanges:subscribe',
                    value
                });
                if (value != null) {
                    this.groupNameAdd = value;
                } else {
                    this.groupNameAdd = '';
                }
            });

        this.addGroupsForm.controls['purpose'].valueChanges
            .pipe(
                takeWhile(() => this.componentActive),
                startWith(''),
                tap(value =>
                    this.log.debug({
                        type: 'GroupsAddComponent:purpose:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'GroupsAddComponent:purpose:valueChanges:subscribe',
                    value
                });
                if (value != null) {
                    this.purposeAdd = value;
                } else {
                    this.purposeAdd = '';
                }
            });
    }
}
